<div class="card-action mb-1" [class.card-action--mobile]="isMobile()">
  <!-- Playback/Display Controls -->
  <div class="control-buttons" [class.control-buttons--horizontal]="isMobile()">
    @if (isMultiSelectMode()) {
      <ui-checkbox class="multi-select-checkbox" [checked]="isSelected()" (click)="$event.stopPropagation()" (checkedChange)="toggleSelection()"></ui-checkbox>
    } @else {
      @if (chunk()?.syncState === 'failed') {
        <button class="playback-control text-amber-500!" mat-icon-button [matTooltip]="'ChunkController.Tooltip.CreationFailed' | translate" matTooltipPosition="right" (click)="retrySync($event)">
          <mat-icon class="text-amber-500!">sync_problem</mat-icon>
        </button>
      } @else if (chunk()?.isPlaceHolder || generatingAudio() || hasActiveTask()) {
        @if (showDragIndicatorDuringLongProcessing() && !readOnly()) {
          <button
            class="playback-control"
            mat-icon-button
            cdkDragHandle
            [matTooltip]="'ChunkController.Tooltip.OptionsOrDrag' | translate"
            matTooltipPosition="right"
            (click)="openOptions($event); onPause()"
          >
            <mat-icon>drag_indicator</mat-icon>
          </button>
        }
        <div class="flex items-center justify-center w-[40px] h-[40px] p-2">
          <mat-progress-spinner [diameter]="18" mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else {
        @if (isPlaying()) {
          <button
            mat-icon-button
            class="playback-control"
            [@showHideControls]
            (click)="onPrevious()"
            [disabled]="!hasPreviousChunk()"
            [matTooltip]="'AudioPlayer.Tooltip.Previous' | translate"
            matTooltipPosition="right"
          >
            <mat-icon>skip_previous</mat-icon>
          </button>
        } @else {
          @if (!readOnly()) {
            <button
              #optionsButton
              class="playback-control"
              [@showHideControls]
              mat-icon-button
              cdkDragHandle
              [matTooltip]="'ChunkController.Tooltip.OptionsOrDrag' | translate"
              matTooltipPosition="right"
              (click)="openOptions($event); onPause()"
            >
              <mat-icon>drag_indicator</mat-icon>
            </button>
          }
        }

        <div class="play-pause-container">
          @if (isPlaying()) {
            <mat-progress-spinner class="progress-spinner" color="primary" [diameter]="40" mode="determinate" [value]="playerProgress()"></mat-progress-spinner>
          }
          @if (!isPlaying()) {
            <button mat-icon-button class="play-pause-button" [matTooltip]="'ChunkController.Tooltip.Play' | translate" matTooltipPosition="right" (click)="onPlay()">
              <mat-icon>play_arrow</mat-icon>
            </button>
          }
          @if (isPlaying()) {
            <button mat-icon-button class="play-pause-button" [matTooltip]="'ChunkController.Tooltip.Pause' | translate" matTooltipPosition="right" (click)="onPause()">
              <mat-icon>pause</mat-icon>
            </button>
          }
        </div>

        @if (isTextual() && !readOnly() && isContentEditor() && !isPlaying() && !isMultiSelectMode()) {
          <div class="dictation-recorder-container mt-1">
            <app-live-dictation-button [chunkId]="chunk()._id" [contentId]="contentID()"></app-live-dictation-button>
          </div>
        }

        @if (isPlaying()) {
          <button
            mat-icon-button
            class="playback-control"
            [@showHideControls]
            (click)="onNext()"
            [disabled]="!hasNextChunk()"
            [matTooltip]="'AudioPlayer.Tooltip.Next' | translate"
            matTooltipPosition="right"
          >
            <mat-icon>skip_next</mat-icon>
          </button>
        }
        @if (isPlaying()) {
          <div class="playback-rate-container" [class.playback-rate-container--horizontal]="isMobile()" (mouseenter)="onMouseEnterPlaybackRate()" (mouseleave)="onMouseLeavePlaybackRate()">
            <button mat-flat-button class="playback-rate-button" [@showHideControls] (click)="onChangePlaybackRate()">{{ playbackRate() }}x</button>
            @if (showPlaybackRateOptions()) {
              <div class="playback-rate-options" [class.playback-rate-options--above]="isMobile()" [@slideInOut]>
                @for (rate of allPlaybackRates; track rate) {
                  @if (rate !== playbackRate()) {
                    <button mat-flat-button class="playback-rate-option-button" (click)="onSetSpecificPlaybackRate(rate)">{{ rate }}x</button>
                  }
                }
              </div>
            }
          </div>
        }

        @if (isHighlighted() && !isPlaying() && chunk()?.type === 'latex') {
          <button
            mat-icon-button
            class="confirm-edit-button"
            [@showHideControls]
            (click)="unhighlightChunk($event)"
            [matTooltip]="'ChunkController.Tooltip.ConfirmEdit' | translate"
            matTooltipPosition="right"
          >
            <mat-icon>check</mat-icon>
          </button>
        }
      }
    }
  </div>
</div>

<!-- Editor Section -->
<!-- Disabled for now : 2026-01-11 by Ibrahima Sarr -->
<!-- <div id="editor-in-chunk">
<div class="chunkCreationError">
  @switch (chunk().error) {
    @case ('creation') {
      <span>{{ 'ChunkDisplayer.errors.creation' | translate }}</span>
    }
    @case ('translation') {
      <span>{{ 'ChunkDisplayer.errors.translation' | translate }}</span>
    }
    @case ('tts') {
      <span>{{ 'ChunkDisplayer.errors.tts' | translate }}</span>
    }
    @case ('nointernet') {
      <span>{{ 'ChunkDisplayer.errors.nointernet' | translate }}</span>
    }
  }
</div>

@switch (chunk().editMode) {
  @case ('voiceOver') {
    <div>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Courses.ChunkCreator.SelectLanguage' | translate }}</mat-label>
        <mat-select [(value)]="voiceOverParams.language">
          @for (language of chunkLanguages(); track language.value) {
            <mat-option [value]="language.value">{{ language.viewValue }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @case ('addAudio') {
    <div>
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Courses.ChunkCreator.SelectLanguage' | translate }}</mat-label>
        <mat-select [(value)]="selectedVoiceLanguage" (selectionChange)="selectVoiceOptions()">
          @for (language of chunkLanguages(); track language.value) {
            <mat-option [value]="language.value">{{ language.viewValue }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
}
</div> -->
